<div class="row justify-content-center">
    <div class="col-md-4  mt-5">
        <router-outlet></router-outlet>
    </div>
</div>